import { useFocusWithin } from "@circle-react/hooks/utils/useFocusWithin";
import { useBlockWithConnectorData } from "./BlockWithConnectorDataProvider";

export interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  closeOnBlur?: boolean;
}

export const Container = ({
  closeOnBlur = false,
  children,
  ...rest
}: ContainerProps) => {
  const { setActiveItemId } = useBlockWithConnectorData();

  const onBlurWithinHandler = () => {
    setActiveItemId(undefined);
  };

  const { focusWithinProps } = useFocusWithin({
    onBlurWithin: onBlurWithinHandler,
  });

  if (!closeOnBlur) {
    return <div {...rest}>{children}</div>;
  }

  return (
    <div {...rest} {...focusWithinProps}>
      {children}
    </div>
  );
};
